import React from 'react'
import type { ComponentConfig } from '@puckeditor/core'
import { WithLayout, withLayout } from '../Layout'
import { Icon, iconField } from '../../fields/IconField'
import { ColorField } from '../../fields/ColorField'

export type IconBlockProps = WithLayout<{
  icon?: string
  color?: string
  size?: string
}>

const IconInternal: ComponentConfig<IconBlockProps> = {
  label: 'Icon',
  fields: {
    icon: { ...iconField, label: 'Icon' },
    color: {
      type: 'custom',
      label: 'Color',
      render: (props: React.ComponentProps<typeof ColorField>) => (
        <ColorField {...props} clearable />
      ),
    },
    size: { type: 'text', label: 'Size', placeholder: 'e.g. 24px, 2rem' },
  },
  defaultProps: {
    icon: 'lucide:Star',
    color: '',
    size: '24px',
  },
  render: ({ icon, color, size }) => (
    <Icon value={icon} color={color || undefined} size={size || 24} />
  ),
}

export const PuckIcon = withLayout(IconInternal)
